// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"141fb630","247":"a22ebc9f","453":"abd36b29"}[chunkId] + ".chunk.js";
};